import { memo, useMemo } from "react";

import type { QuestionnairePayload } from "../../form-builder/types";

import type { QuestionPreviewItem } from "src-next/shared/ui/questionnaire-form-renderer";
import {
  EMPTY_OPTIONS_MESSAGE,
  PREVIEW_EMPTY_MESSAGE,
} from "../../form-builder/utils";
import { PreviewExpandDialog } from "../../form-builder/components";

export interface QuestionnairePreviewDialogProps {
  open: boolean;
  questionnaire: QuestionnairePayload | null;
  onClose: () => void;
}

function toQuestionPreviewItems(
  questions: QuestionnairePayload["questions"],
): QuestionPreviewItem[] {
  return questions.map((question) => ({
    id: question.id,
    label: question.label,
    type: question.type,
    isRequired: question.isRequired,
    helperText: question.helperText,
    optionsCsv: question.optionsCsv,
  }));
}

const QuestionnairePreviewDialog = memo(
  ({ open, questionnaire, onClose }: QuestionnairePreviewDialogProps) => {
    const previewItems = useMemo(() => {
      if (!questionnaire) return [];
      return toQuestionPreviewItems(questionnaire.questions);
    }, [questionnaire]);

    return (
      <PreviewExpandDialog
        open={open}
        onClose={onClose}
        questions={previewItems}
        title={questionnaire?.title}
        description={questionnaire?.description}
        emptyMessage={PREVIEW_EMPTY_MESSAGE}
        emptyOptionsMessage={EMPTY_OPTIONS_MESSAGE}
      />
    );
  },
);

QuestionnairePreviewDialog.displayName = "QuestionnairePreviewDialog";

export default QuestionnairePreviewDialog;
